import type { SxProps, Theme } from '@mui/material/styles';

/** Shared paper styles for company/valuation folder pickers in Operations. */
export const FOLDER_PICKER_POPOVER_PAPER_SX: SxProps<Theme> = {
  width: 360,
  maxWidth: '90vw',
  // Fixed height so selecting/expanding folders cannot resize the paper and nudge position.
  height: 420,
  maxHeight: 'calc(100dvh - 32px)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const FOLDER_PICKER_TREE_MAX_HEIGHT_PX = 200;

export const FOLDER_PICKER_PATH_SX: SxProps<Theme> = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minHeight: 20,
};
